import options from "amplitude-js";

export const mixinDialogMutations = {
  OPEN_DIALOG: (state, dialog) => {
    if (typeof dialog === 'object') { // dialog can be an object, it needs to have - 'name': string, and 'props': object
      state.dialogs[dialog.name] = true

      for (let option in dialog.props) {
        state[option] = dialog.props[option]
      }
    } else {
      state.dialogs[dialog] = true
    }
  },

  CLOSE_DIALOG: (state, dialog) => {
    state.dialogs[dialog] = false
  }
}

export const mixinDialogActions = {
  async openDialog (context, dialog) {
    context.commit('OPEN_DIALOG', dialog)
  },

  async closeDialog (context, dialog) {
    context.commit('CLOSE_DIALOG', dialog)
  }
}

export const mixinDialogGetters = {
  dialogs: state => state.dialogs
}
